export default {
  'bindTo': 'this',
  'method': function(){
    alert('Sincronizza AGYO')
  },
}
